import axios from 'services/http';
import { CancelTokenSource } from 'axios';
import { BillDocumentDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/bill-documents/`;

export const getAllBillDocuments = (source: CancelTokenSource): Promise<Array<BillDocumentDto>> => {
  return axios
      .get(`${apiUri}`, {cancelToken: source.token})
      .then(response => response.data);
};
